var map = {
	"./AlipayHK_HK.png": 3051,
	"./AmazonPay.svg": 4446,
	"./BankCard1.png": 4109,
	"./BitPay.svg": 2089,
	"./Bitcash.svg": 9888,
	"./DollarGeneralCard.svg": 9924,
	"./Giropay.svg": 6173,
	"./INGBank.png": 2754,
	"./KAKAOPAY.png": 5593,
	"./Klarna.png": 3605,
	"./Konbini.svg": 6692,
	"./LINEPay.png": 2744,
	"./NAVERPay.svg": 928,
	"./PayEasy.svg": 1360,
	"./PayPal.svg": 4261,
	"./PayPay_JP.png": 7549,
	"./Payco.svg": 1432,
	"./Samsung Pay.webp": 8983,
	"./Toss.svg": 5349,
	"./Trustly.svg": 3515,
	"./Venmo.svg": 7515,
	"./WeChat_Pay_HK.png": 1707,
	"./abnamro.png": 4926,
	"./applepay.svg": 3482,
	"./bankTransfer.svg": 7359,
	"./banner_1.png": 2576,
	"./crypto.svg": 315,
	"./eNETS_SG.png": 3444,
	"./failure.svg": 2382,
	"./googlepay.svg": 149,
	"./grabpay.png": 3592,
	"./iDEAL.png": 4139,
	"./icon.png": 8785,
	"./id.png": 6861,
	"./loginInput.b76f4e4d.webp": 9950,
	"./mycard.svg": 4688,
	"./netbank.png": 4135,
	"./payermax.png": 4669,
	"./paysafecard.svg": 7207,
	"./paysafecash.png": 612,
	"./point.png": 4294,
	"./point.svg": 2978,
	"./rabobank.png": 3582,
	"./sberbank.png": 2438,
	"./sbp_eng.svg": 7312,
	"./sbp_logo_t.png": 9486,
	"./strongest_castle.png": 1040,
	"./success.svg": 8705,
	"./tinkbank.svg": 5618,
	"./top-logo.webp": 9666,
	"./wrong.svg": 1631,
	"./xsolla.png": 7821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3140;